import { Component, OnInit,ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { VisitaService } from '../services/visita.service';
import {GlobalsService} from '../services/globals.service'
import { ReporteViajeService } from '../services/reporte-viaje.service';

import { Visita } from '../Models/Visita';
import { ReporteTarea } from '../Models/ReporteTarea';

import {
  AccessibilityConfig, Action, AdvancedLayout, ButtonEvent, ButtonsConfig, ButtonsStrategy, ButtonType, Description, DescriptionStrategy, GalleryService,
  DotsConfig, GridLayout, Image, ImageModalEvent, LineLayout, PlainGalleryConfig, PlainGalleryStrategy, PreviewConfig
} from 'angular-modal-gallery';

@Component({
  selector: 'app-reporte-devolucion-libre',
  templateUrl: './reporte-devolucion-libre.component.html',
  styleUrls: ['./reporte-devolucion-libre.component.css']
})
export class ReporteDevolucionLibreComponent implements OnInit {

  public visita: Visita = new Visita();
  public visitas: Visita[];

  public fechaInicio: Date;
  public fechaFin: Date;

  public reporteTareas: ReporteTarea[];

  public mostrar : boolean=false;
  image: Image;
  images1: Image[];
  public path: any;

  constructor(
    private visitaService:VisitaService,
    private globalServices:GlobalsService,
    private reporteViajeService: ReporteViajeService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }


   //carga la lista de visitas referentes a la fecha
   CargarVisitas() {
    try {

      this.visitaService.ObtenerVisitasProcesado(this.globalServices.ObtenerCompania(), this.fechaInicio, this.fechaFin).subscribe(
        data => {
          this.visitas = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVisitas: " + error);
    }
  }

  RegistroSeleccionado(item) {

    this.visita = JSON.parse(JSON.stringify(item));

    this.CargarReporteGaleria();

  }



 /**
   * Carga la vista de la galeria
   */
  CargarReporteGaleria() {

    try {
    // EL TIPO DEVOLUCIONLIBRE, ES LA NOTA PARA CUANDO HACE UNA DEVOLUCION LIBRE
      this.reporteViajeService.ObtenerReporteGaleria(this.globalServices.ObtenerCompania(), this.visita.idVisita,'DEVOLUCIONLIBRE').subscribe(
        data => {
          this.reporteTareas = data;
          this.mostrar = true;

          let count = 0;
          let arrayimagen = [];

          this.reporteTareas.forEach(element => {
            this.path = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + element.imagen);

            count += 1;

            this.image = new Image(count, { img: this.path, description: element.descripcion });
            arrayimagen.push(this.image);
            element.image=this.image;

          });
          this.images1 = arrayimagen;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteGaleria: " + error);
    }


  }

  plainGalleryGrid: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.GRID,
    layout: new GridLayout({ width: '80px', height: '80px' }, { length: 3, wrap: true })
  };

}
